export const CancellationMixin = {
    data() {
        return {
            policies: {}, 
        }
    },
    computed: {
        userRole() {
            return localStorage.getItem("user_role");
          },  
    },
    methods:
    {
        addPolicy(policyObject)
        {
            fetch(this.$api + 'cancellations/penalties', {
                method: 'POST',
                body: JSON.stringify(policyObject),
                headers:{
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            }).then(res => res.json())
            .then(response => {
                
                if (response.status) {
                    this.$notify({
                        type: 'success',
                        title: response.message
                    });
                    
                    this.$router.push({ name: 'cancellation-index'})
                }else{
                    this.$notify({
                        type: 'error',
                        title: response.message
                    });
                }
            }).catch((error) => {
                this.$notify({
                    type: 'error',
                    title: error.message
                });
            })
        },
        async editPolicy(policy_id) {
            return fetch(`${this.$api}cancellations/${policy_id}/get-policy`, {
                method: 'POST',
                headers:{
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': localStorage.getItem('token')
                }
            }).then(res => res.json())
            .then(response => {
               return response
            }).catch((error) => {
                this.$notify({
                    type: 'error',
                    title: error.message
                });
            })
        },
        
    }
}